import { useEffect } from 'react';

export const usePrefetch = () => {
  useEffect(() => {
    // Prefetch critical fonts
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/woff2';
    link.crossOrigin = 'anonymous';
    link.href = 'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hiA.woff2';
    document.head.appendChild(link);

    // Prefetch images in ProfileCarousel
    const imagesToPrefetch = [
      '/lovable-uploads/35b1a03a-d045-4862-b833-030a66a6798b.png',
      '/lovable-uploads/ce4b1145-2de3-4613-830a-3d7ab999e715.png',
      '/lovable-uploads/ce0e76d4-a63b-4844-ac1e-3d987cb0e804.png',
    ];

    imagesToPrefetch.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, []);
};